import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logoCroppedConvertido.webp'


const _withScopeId = n => (_pushScopeId("data-v-caf8afde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"footer__contactUs\" data-v-caf8afde><h3 data-v-caf8afde>Contact Us</h3><div class=\"contactUs__data\" data-v-caf8afde><div class=\"data__item\" data-v-caf8afde><i class=\"far fa-envelope\" data-v-caf8afde></i><a href=\"mailto:hello@chatterboxenglishstudio\n          .com?subject=Hola Chatterbox! Quisiera hacer una consulta...\" data-v-caf8afde><h2 id=\"mail\" data-v-caf8afde>hello@chatterboxenglishstudio.com</h2></a></div><div class=\"data__item\" data-v-caf8afde><i class=\"fas fa-phone\" data-v-caf8afde></i><a href=\"tel:+5491133062666\" data-v-caf8afde><h2 data-v-caf8afde>+549 11 3306 2666</h2></a></div></div></section>", 1)
const _hoisted_3 = { class: "footer__redes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "redes__logo",
  src: _imports_0,
  alt: "Logo de Chatterbox English Studio"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"redes__iconos\" data-v-caf8afde><a href=\"https://www.facebook.com/chatterboxenglishstudio\" target=\"_blank\" rel=\"noreferrer\" data-v-caf8afde><i class=\"fab fa-facebook-square\" data-v-caf8afde></i></a><a href=\"https://www.instagram.com/chatterbox.englishstudio\" target=\"_blank\" rel=\"noreferrer\" data-v-caf8afde><i class=\"fab fa-instagram-square\" data-v-caf8afde></i></a><a href=\"https://wa.me/5491133062666?text=Hola%20Chatterbox%21%0AMe%20gustar%C3%ADa%20hacer%20una%20consulta...\" target=\"_blank\" rel=\"noreferrer\" data-v-caf8afde><i class=\"fab fa-whatsapp-square\" data-v-caf8afde></i></a><a href=\"https://www.linkedin.com/company/chatterboxenglishstudio\" target=\"_blank\" rel=\"noreferrer\" data-v-caf8afde><i class=\"fab fa-linkedin\" data-v-caf8afde></i></a></div>", 1)
const _hoisted_6 = { class: "footer__navigation" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Navigation", -1))
const _hoisted_8 = { class: "navigation__list" }
const _hoisted_9 = { class: "navigation__item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("HOME")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("CLASSES")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("COMPANIES")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "redes__link"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _createElementVNode("section", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            class: "navigation__link",
            to: { name: 'Home' }
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "navigation__link",
            to: { name: 'Classes' }
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "navigation__link",
            to: { name: 'Companies' }
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}